import moment from 'moment';

    export default function(raw_date) {
        // 2017-02-15 22:15:43 -08:00
        return moment(raw_date).format('YYYY-MM-DD HH:mm:ss Z');
    }

